<template>
  <div class="tourListCassetteMainContents">
    <!-- GOTO割引表示は非表示とする
    <div
      v-if="!!discounted"
      class="tourListCassetteMainContents_price"
    >
      <p class="tourListCassetteMainContents_priceLabel -red">支払実額</p>
      <p class="tourListCassetteMainContents_priceAmount -red -large">{{ makeDisplayPrice(discounted) }}</p>
    </div>
    -->
    <div class="tourListCassetteMainContents_price">
      <p class="tourListCassetteMainContents_priceLabel">旅行代金</p>
      <p class="tourListCassetteMainContents_priceAmount">{{ makeDisplayPrice(price) }}</p>
    </div>
    <div class="tourListCassetteMainContents_buttonArea">
      <div class="tourListCassetteMainContents_detailButton">
        <tk-link
          class="tourListCassetteMainContents_detailUrl"
          :href="makeDetailPageUrl(tourCode)"
          target="_blank"
        >
          ツアー詳細を見る
        </tk-link>
        <tk-right-arrow class="tkRightArrowButton_arrow"/>
      </div>
    </div>
  </div>
</template>

<script>
import { uniq } from 'lodash'
import {
  TkLink,
  TkRightArrow,
} from '@ota-frontend/ui'

export default {
  name: 'TourListCassetteMainContents',
  components: {
    TkLink,
    TkRightArrow,
  },
  props: {
    tourCode: {
      type: String,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
    discounted: {
      type: Object,
      default: () => ({}),
    },
    makeDetailPageUrl: {
      type: Function,  // tourCode => url
      required: true,
    },
  },
  methods: {
    makeDisplayPrice(tour) {
      return tour.fixedPrice
        ? `${tour.fixedPrice.toLocaleString()}円`
        : uniq([tour.minPrice || tour.min, tour.maxPrice || tour.max])
          .filter(Boolean)
          .map(p => `${p.toLocaleString()}円`)
          .join('～')
    },
  },
}
</script>

<style scoped lang="scss">
.tourListCassetteMainContents_price {
  display: flex;
  align-items: flex-start;
  margin: auto auto 10px auto;
}
.tourListCassetteMainContents_priceLabel {
  border: 1px solid #63666a;
  text-align: center;
  font-size: 11px;
  border-radius: 15px;
  padding: 2px 5px;
  width: 70px;

  &.-red {
    color: #f9423a;
    border-color: #f9423a;
  }
}
.tourListCassetteMainContents_priceAmount {
  margin-top: 0px;
  font-weight: bold;
  font-size: 19px;
  padding-left: 5px;
  margin-bottom: 0;

  &.-red {
    color: #f9423a;
  }
  &.-large {
    font-size: 20px;
  }
}

.tourListCassetteMainContents_buttonArea {
  margin-top: 8px;
  margin-bottom: 0px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.tourListCassetteMainContents_favoriteButton {
  margin-right: 10px;
}
.tourListCassetteMainContents_detailButton {
  background-color: #F9423A;
  border-radius: 4px;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  font-weight: bold;
  position: relative;
  text-align: center;
  /* [暫定]お気に入り非表示対応 開始
  width: calc(100% - 50px);
  */
  width: 100%;
  // [暫定]お気に入り非表示対応 終了
  height: 45px;
  padding: 0px 10px 0px 0px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: #c5130b 0px 4px;
  letter-spacing: 1.5px;

  .tourListCassetteMainContents_detailUrl {
    display: block;
    width: 100%;
    color: #ffffff;
    text-decoration: none;
  }
}
</style>
